$(document).ready(function() {
  const options = {
    // DOM elements to slick.
    selectorsForSlick: ['.block-steps .steps', '.slides-reference .slides'],
    // DOM elements that have slide on desktop
    selectorForSlide: '.slides-reference .slide-links .slide-link',
    // Slick below this many pixels.
    breakpoint: 800,
  }

  const $window = $(window);
  var slicked = undefined;
  var slided = undefined;

  const toggle = () => {
    if($window.width() <= options.breakpoint) {
      slick();
      unSlide();
    } else {
      unslick();
      slide();
    }
  };

  const slide = () => {
    if(slided) return;
    $(options.selectorForSlide).slide({
      selectorForSlideLinks: '.slides-reference .slide-links',
      selectorForSlides: '.slides-reference .slides'
    });
    slided =true;
  };

  const unSlide = () => {
    if(!slided) return;
    $(options.selectorForSlide).off('click');
    slided = false;
  };

  const slick = () => {
    if(slicked) return;
    options.selectorsForSlick.forEach(function(selector){
      $(selector).slick({
        dots: true,
        arrows: false,
        variableWidth: true,
      });
    });
    slicked = true;
  };

  const unslick = () => {
    if(!slicked) return;
    options.selectorsForSlick.forEach(function(selector){
      $(selector).slick('unslick');
    });

    slicked = false;
  };

  toggle();

  $window.on('resize', toggle);
});
